import React from 'react';
import { useHistory } from 'react-router-dom';
import BetterButton from '../../components/mellro-primitives/BetterButton';

export default function NotFound() {
	const history = useHistory();

	return (
		<div style={{
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			gap: 54,
			padding: '80px 40px',
			minHeight: '70vh',
			color: 'var(--text-primary)',
		}}>
			<div style={{
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				justifyContent: 'center',
				gap: 12,
				maxWidth: 368,
				textAlign: 'center',
			}}>
				<h1 style={{
					fontSize: 56,
					fontWeight: 900,
					lineHeight: '72px',
					letterSpacing: 1,
					margin: 0,
					color: 'var(--text-primary)',
					fontFamily: 'var(--font-family)',
				}}>
					404
				</h1>

				<h2 style={{
					fontSize: 'var(--font-size-xl)',
					fontWeight: 'var(--font-weight-semibold)',
					lineHeight: 'var(--line-height-base)',
					letterSpacing: 0.3,
					margin: 0,
					color: 'var(--text-primary)',
					fontFamily: 'var(--font-family)',
				}}>
					Não encontramos a página que você buscou.
				</h2>

				<p style={{
					fontSize: 'var(--font-size-sm)',
					fontWeight: 'var(--font-weight-regular)',
					lineHeight: 'var(--line-height-base)',
					letterSpacing: 0.3,
					margin: 0,
					color: 'var(--text-secondary)',
					fontFamily: 'var(--font-family)',
				}}>
					Verifique o endereço ou volte para a tela inicial.
				</p>

				<div style={{ marginTop: 8 }}>
					<BetterButton type="primary" onClick={() => history.push('/dashboard')}>
						Voltar para a dashboard
					</BetterButton>
				</div>
			</div>

			<div style={{
				flexShrink: 0,
				maxWidth: 420,
				width: '100%',
			}}>
				<img
					src="/images/not-found/mel_raiva_2.png"
					alt="Página não encontrada"
					style={{ width: '100%', objectFit: 'contain' }}
				/>
			</div>
		</div>
	);
}
